import * as ambassadorWixEcomV1EcommerceSettings from './ecom-v1-ecommerce-settings-ecommerce-settings.http.js';
import * as ambassadorWixEcomV1EcommerceSettingsTypes from './ecom-v1-ecommerce-settings-ecommerce-settings.types.js';
import * as ambassadorWixEcomV1EcommerceSettingsUniversalTypes from './ecom-v1-ecommerce-settings-ecommerce-settings.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getEcommerceSettings(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixEcomV1EcommerceSettingsUniversalTypes.GetEcommerceSettingsRequest,
  ambassadorWixEcomV1EcommerceSettingsTypes.GetEcommerceSettingsRequest,
  ambassadorWixEcomV1EcommerceSettingsUniversalTypes.GetEcommerceSettingsResponse,
  ambassadorWixEcomV1EcommerceSettingsTypes.GetEcommerceSettingsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1EcommerceSettings.getEcommerceSettings(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/ecommerce-settings',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EcommerceSettings as EcommerceSettingsOriginal,
  ServicePluginConfiguration as ServicePluginConfigurationOriginal,
  ActiveProvider as ActiveProviderOriginal,
  TriggerFlow as TriggerFlowOriginal,
  TriggerFlowWithLiterals as TriggerFlowWithLiteralsOriginal,
  TaxConfiguration as TaxConfigurationOriginal,
  DiscountRulesConfiguration as DiscountRulesConfigurationOriginal,
  CheckoutSettings as CheckoutSettingsOriginal,
  CheckoutPolicies as CheckoutPoliciesOriginal,
  TermsAndConditionsPolicy as TermsAndConditionsPolicyOriginal,
  PrivacyPolicy as PrivacyPolicyOriginal,
  ReturnPolicy as ReturnPolicyOriginal,
  DigitalItemPolicy as DigitalItemPolicyOriginal,
  ContactUsPolicy as ContactUsPolicyOriginal,
  CustomCheckoutPolicy as CustomCheckoutPolicyOriginal,
  CheckoutFields as CheckoutFieldsOriginal,
  CheckboxField as CheckboxFieldOriginal,
  CheckoutBrand as CheckoutBrandOriginal,
  CheckoutHeader as CheckoutHeaderOriginal,
  Logo as LogoOriginal,
  Image as ImageOriginal,
  FocalPoint as FocalPointOriginal,
  LogoSize as LogoSizeOriginal,
  LogoSizeWithLiterals as LogoSizeWithLiteralsOriginal,
  Alignment as AlignmentOriginal,
  AlignmentWithLiterals as AlignmentWithLiteralsOriginal,
  ContinueShopping as ContinueShoppingOriginal,
  DisplayType as DisplayTypeOriginal,
  DisplayTypeWithLiterals as DisplayTypeWithLiteralsOriginal,
  BackgroundFill as BackgroundFillOriginal,
  BackgroundFillOptionsOneOf as BackgroundFillOptionsOneOfOriginal,
  CheckoutMain as CheckoutMainOriginal,
  ExpressButtonsCornerRadius as ExpressButtonsCornerRadiusOriginal,
  ExpressButtonsCornerRadiusWithLiterals as ExpressButtonsCornerRadiusWithLiteralsOriginal,
  CheckoutFooter as CheckoutFooterOriginal,
  CheckoutGlobal as CheckoutGlobalOriginal,
  InputFieldBackgroundStyle as InputFieldBackgroundStyleOriginal,
  InputFieldBackgroundStyleWithLiterals as InputFieldBackgroundStyleWithLiteralsOriginal,
  CheckoutBillingFields as CheckoutBillingFieldsOriginal,
  CheckoutBillingFieldsWithLiterals as CheckoutBillingFieldsWithLiteralsOriginal,
  DeliveryConfiguration as DeliveryConfigurationOriginal,
  DestinationScope as DestinationScopeOriginal,
  DestinationScopeWithLiterals as DestinationScopeWithLiteralsOriginal,
  Destination as DestinationOriginal,
  CountryDeliveryProperties as CountryDeliveryPropertiesOriginal,
  DeliveryDestinationProperties as DeliveryDestinationPropertiesOriginal,
  SubdivisionDeliveryProperties as SubdivisionDeliveryPropertiesOriginal,
  BusinessProperties as BusinessPropertiesOriginal,
  Locale as LocaleOriginal,
  Address as AddressOriginal,
  StreetAddress as StreetAddressOriginal,
  InvalidateCache as InvalidateCacheOriginal,
  InvalidateCacheGetByOneOf as InvalidateCacheGetByOneOfOriginal,
  App as AppOriginal,
  Page as PageOriginal,
  URI as URIOriginal,
  File as FileOriginal,
  CustomTag as CustomTagOriginal,
  Pages as PagesOriginal,
  URIs as URIsOriginal,
  GetEcommerceSettingsRequest as GetEcommerceSettingsRequestOriginal,
  RequestedFields as RequestedFieldsOriginal,
  RequestedFieldsWithLiterals as RequestedFieldsWithLiteralsOriginal,
  GetEcommerceSettingsResponse as GetEcommerceSettingsResponseOriginal,
  Error as ErrorOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  FeatureEvent as FeatureEventOriginal,
  FeatureEventEventOneOf as FeatureEventEventOneOfOriginal,
  FeatureEnabled as FeatureEnabledOriginal,
  FeatureEnabledReasonOneOf as FeatureEnabledReasonOneOfOriginal,
  Feature as FeatureOriginal,
  FeatureQuantityInfoOneOf as FeatureQuantityInfoOneOfOriginal,
  FeatureContext as FeatureContextOriginal,
  BooleanFeature as BooleanFeatureOriginal,
  QuotaFeature as QuotaFeatureOriginal,
  FeaturePeriod as FeaturePeriodOriginal,
  FeaturePeriodWithLiterals as FeaturePeriodWithLiteralsOriginal,
  QuotaInfo as QuotaInfoOriginal,
  QuotaInfoEntry as QuotaInfoEntryOriginal,
  TransferredFromAnotherAccountReason as TransferredFromAnotherAccountReasonOriginal,
  ReassignedFromSiteReason as ReassignedFromSiteReasonOriginal,
  AssignedFromFloatingReason as AssignedFromFloatingReasonOriginal,
  NewFeatureReason as NewFeatureReasonOriginal,
  ContractSwitchedReason as ContractSwitchedReasonOriginal,
  ContractSwitchClassification as ContractSwitchClassificationOriginal,
  ContractSwitchClassificationWithLiterals as ContractSwitchClassificationWithLiteralsOriginal,
  ManualFeatureCreationReason as ManualFeatureCreationReasonOriginal,
  MigratedFromLegacyReason as MigratedFromLegacyReasonOriginal,
  ManualSyncReason as ManualSyncReasonOriginal,
  FeatureDisabled as FeatureDisabledOriginal,
  FeatureDisabledReasonOneOf as FeatureDisabledReasonOneOfOriginal,
  UnAssingedToFloatingReason as UnAssingedToFloatingReasonOriginal,
  ReplacedByAnotherSubscriptionReason as ReplacedByAnotherSubscriptionReasonOriginal,
  ReassignedToAnotherSiteReason as ReassignedToAnotherSiteReasonOriginal,
  FeatureUpdated as FeatureUpdatedOriginal,
  FeatureUpdatedPreviousQuantityInfoOneOf as FeatureUpdatedPreviousQuantityInfoOneOfOriginal,
  FeatureUpdatedReasonOneOf as FeatureUpdatedReasonOneOfOriginal,
  FeatureCancelled as FeatureCancelledOriginal,
  FeatureCancelledReasonOneOf as FeatureCancelledReasonOneOfOriginal,
  TransferredToAnotherAccountReason as TransferredToAnotherAccountReasonOriginal,
  CancelRequestedReason as CancelRequestedReasonOriginal,
  QuotaExhaustedReason as QuotaExhaustedReasonOriginal,
  FeatureQuotaUsageChanged as FeatureQuotaUsageChangedOriginal,
  EcomSitePropertiesChangedEvent as EcomSitePropertiesChangedEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  GetEcommerceSettingsApplicationErrors as GetEcommerceSettingsApplicationErrorsOriginal,
} from './ecom-v1-ecommerce-settings-ecommerce-settings.types.js';
